import {createRouter, createWebHistory} from 'vue-router'
import {routes} from './routes';
import {Component} from "vue";
import {installNavigationProgress} from './navigationProgress';
import {installChunkReload} from './chunkReload';
import {installAuthGuard} from './authGuard';

export {pages as AppPages} from './pages';
export {isRouteLoading} from './navigationProgress';
export * from './types';

const index = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes,
    scrollBehavior(to, from, savedPosition) {
        // Смена только query (например, страница в превью документа) — это не переход, скролл не трогаем
        if (to.path === from.path && to.hash === from.hash) {
            return false;
        }

        if (to.hash) {
            return {
                el: to.hash,
                behavior: 'smooth'
            }
        }

        if (savedPosition) {
            return {
                ...savedPosition,
                behavior: 'instant'
            };
        }

        return {top: 0};
    },
});

installAuthGuard(index);
installNavigationProgress(index);
installChunkReload(index);

export function useRouter() {
    return index;
}

declare module 'vue-router' {
    interface RouteMeta {
        title?: string;
        icon?: Component;
        isHide?: boolean;
        isNavTab?: boolean;
        divider?: 'before' | 'after';
        isNew?: boolean;
        /** Только для вошедших; дочерние маршруты наследуют и могут снять через false */
        requiresAuth?: boolean;
    }
}
